import React from "react";
import { Route } from "react-router-dom";
import QueryBoundary from "../Components/QueryBoundary";

const Home = React.lazy(() => import("../Pages/LandingPage/pages/index"));
const Login = React.lazy(() => import("../Pages/Login"));
const Register = React.lazy(() => import("../Pages/Register"));
const RegisterFromInvitation = React.lazy(() => import("../Pages/RegisterFromInvitation"));
const ForgotPassword = React.lazy(() => import("../Pages/ForgotPassword"));
const PasswordReset = React.lazy(() => import("../Pages/PasswordReset"));
const VerifyEmail = React.lazy(() => import("../Pages/VerifyEmail"));
const VerifyEmailChange = React.lazy(() => import("../Pages/VerifyEmailChange"));
const EmailVerificationNotice = React.lazy(() => import("../Pages/EmailVerificationNotice"));
const ContactUs = React.lazy(() => import("../Pages/ContactUs"));
const NotFoundPage = React.lazy(() => import("../Pages/NotFoundPage"));
const NotAuthorizedPage = React.lazy(() => import("../Pages/NotAuthorizedPage"));

const LazyRoute = QueryBoundary;

export function publicRoutes() {
  return (
    <>
      <Route path="*" element={<LazyRoute><NotFoundPage /></LazyRoute>} />
      <Route path="/unauthorized" element={<LazyRoute><NotAuthorizedPage /></LazyRoute>} />
      <Route path="/" element={<LazyRoute><Home /></LazyRoute>} />
      <Route path="/contact-us" element={<LazyRoute><ContactUs /></LazyRoute>} />
      <Route path="/login" element={<LazyRoute><Login /></LazyRoute>} />
      <Route path="/register" element={<LazyRoute><Register /></LazyRoute>} />
      <Route path="/register/:token" element={<LazyRoute><RegisterFromInvitation /></LazyRoute>} />
      <Route path="/passwordreset/:resetToken" element={<LazyRoute><PasswordReset /></LazyRoute>} />
      <Route path="/forgot-password" element={<LazyRoute><ForgotPassword /></LazyRoute>} />
      <Route path="/verify-email/:token" element={<LazyRoute><VerifyEmail /></LazyRoute>} />
      <Route path="/verify-email-change/:token" element={<LazyRoute><VerifyEmailChange /></LazyRoute>} />
      <Route path="/verify-email-notice" element={<LazyRoute><EmailVerificationNotice /></LazyRoute>} />
    </>
  );
}
